module.exports = __webpack_public_path__ + "img/u1415.afa1e5ab.png";